export default __webpack_public_path__ + "static/media/home-business-blog-img02.d8be4d96.jpg";